import React from 'react';
import { Form, useChanges } from '../../../../../../components/Form/Form';
import { RadioGroup } from '../../../../../../components/Form/Radio/RadioGroup';
import { PercentageField } from '../../../../../../components/Form/TextField/PercentageField';
import { ModalController } from '../../../../../../components/Modal/ControlledModal';
import { t } from '../../../../../../locales/translate';
import { handleError } from '../../../../../../model/notification';
import { setImmediatePaymentRate } from '../../../../../../model/product';
import { linesAsBulletpoints } from '../../../../../../util/react-util';
import { immediatePaymentSelection } from '../CheckoutOptions';

export function PaymentOptionsForm({
  controller,
  productId,
  productType,
}: {
  controller: ModalController<{ value: number | null }>;
  productId: string;
  productType: 'event' | 'product';
}): JSX.Element {
  const [, , model, trackChanges] = useChanges(controller.model);
  const state = immediatePaymentSelection(model.value);

  async function handleOnSubmit(): Promise<void> {
    try {
      if (model.value !== null) {
        await setImmediatePaymentRate({
          immediatePaymentAtStockQuota: model.value,
          productId,
          type: productType,
        });
        controller.close();
      }
    } catch (error) {
      handleError(error);
    }
  }

  return (
    <Form model={model} onInput={trackChanges}>
      {(form) => {
        controller.configure({
          onSubmit: handleOnSubmit,
          canSubmit: form.valid,
        });
        return (
          <>
            <RadioGroup
              name="value"
              layout="list"
              values={[
                { label: t.model.event.instantPaymentDescription.only, value: 0 },
                { label: t.model.event.instantPaymentDescription.all, value: 1 },
                { label: t.model.event.instantPaymentDescription.custom, value: 0.8, checked: state === 'custom' },
              ]}
            ></RadioGroup>
            {state === 'custom' && (
              <PercentageField
                name="value"
                label={`${t.model.event.instantPaymentLabel} (%)`}
                description={linesAsBulletpoints(t.model.event.instantPaymentCustomDescription)}
                min={0}
                max={100}
              />
            )}
          </>
        );
      }}
    </Form>
  );
}
